// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"412d42c6","408":"239737ec","668":"a60a93fe","977":"63649ca0"}[chunkId] + ".chunk.js";
};